import { consoleTracker } from './consoleTracker';
import { segmentTracker } from './segmentTracker';

const isDevMode = import.meta.env.REACT_APP_SEGMENT_DEV_MODE === 'true';
export const tracker = isDevMode ? consoleTracker : segmentTracker;
